// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__z2F0X","footer":"styles_footer__1soMW","passCodeTooltip":"styles_passCodeTooltip__Nrl7O"};